import { memo, useEffect, useMemo, useRef } from 'react';
import JSONEditor from 'jsoneditor/dist/jsoneditor';
import 'jsoneditor/dist/jsoneditor.min.css';

const defaultOptions = {
  mode: 'tree',
  history: true,
  search: true,
  navigationBar: true,
  statusBar: true,
  sortObjectKeys: false,
};

function ReactJsonEditor({ value, options, getJsonEditor, expandAll, containerClassName }) {
  const containerRef = useRef(null);
  const jsonEditorRef = useRef(null);

  const compiledOptions = useMemo(() => ({ ...defaultOptions, ...options }), [options]);

  useEffect(() => {
    if (!containerRef.current) return;

    if (!jsonEditorRef.current) {
      jsonEditorRef.current = new JSONEditor(containerRef.current, compiledOptions, value);
    }

    if (typeof getJsonEditor === 'function') {
      getJsonEditor(jsonEditorRef.current);
    }

    if (expandAll) {
      jsonEditorRef.current.expandAll();
    }

    // eslint-disable-next-line consistent-return
    return () => {
      jsonEditorRef.current?.destroy();
      jsonEditorRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (jsonEditorRef.current && value) {
      jsonEditorRef.current.update(value);
    }
  }, [value]);

  return <div ref={containerRef} className={containerClassName} />;
}

export default memo(ReactJsonEditor);
